define.alias("ember-truth-helpers/helpers/is-array", "settings/helpers/is-array");